<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { useNavigate, useParams } from 'svelte-navigator';

  import { loadTemplate, updatedVariables, variables } from '@client/stores/bizcard';
  import { loadNewBizcardModalTemplates } from '@client/stores/bizcard-templates';

  const navigate = useNavigate();
  const params = useParams();

  export let templateSwitched = false;
  export let source = '';
  export let originalSource = '';

  let templates = [];

  const onSelect = async (template) => {
    const cardModified = JSON.stringify(originalSource) !== JSON.stringify(source);
    const stylesModified = Object.entries($variables).some(
      ([key, value]) => key in $updatedVariables && value !== $updatedVariables[key]
    );

    const modified = cardModified || stylesModified;

    if (modified) {
      const confirmSwitch = confirm($format('label.CONFIRM.SWITCH_TEMPLATES'));

      if (!confirmSwitch) {
        return;
      }
    }

    navigate(`/bizcards/studio/new/${template.id}`);

    await loadTemplate(template.id);

    templateSwitched = true;
  };

  onMount(async () => {
    templates = await loadNewBizcardModalTemplates();
  });
</script>

<div class="bizcard-templates">
  {#each templates as template, index}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="business-card-template"
      class:active={$params.template === template.id}
      class:disable-pointer={$params.template === template.id}
      data-testid="business-card-template-{index}"
      on:click={() => onSelect(template)}
      role="button"
      tabindex="0"
    >
      <div class="card-number text-capitalize">
        {template.name}
      </div>
      <div class="card-wrapper">
        <iframe
          role="button"
          scrolling="no"
          srcdoc="<html><body><div>{template.html}</div></body></html>"
          tabindex="-1"
          title={template.name}
        />
      </div>
    </div>
  {/each}
</div>

<style lang="scss" src="./switch-templates.scss"></style>
